module.exports = __webpack_public_path__ + "img/Level.75c12743.svg";